

























































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { HeadersDataTable } from "@/typings/vuetify/vDataTable";
import { CajaChicaTalca } from "@/typings/store/plugins/easyFirestore/cajaChicasTalca";
import { ItemsTablaCajaChicasTalca } from "@/typings/components/cajaChicasTalca/tabla";
import "@/helpers/extensions";

@Component
export default class TablaCajaChicasTalca extends Vue {
  @Prop() readonly opciones!: boolean;
  @Prop() readonly search!: string;
  @Prop() readonly cajaChicasTalca!: Array<CajaChicaTalca>;
  @Prop() readonly usuario!: string;

  options = { page: 1, itemsPerPage: 7, pageCount: 0 };
  headerProps = { sortIcon: "mdi-chevron-down" };
  footerProps = { itemsPerPageOptions: [5, 10, 15, 25], showFirstLastPage: true, showCurrentPage: true, class: "tabla-caja-gerencial__footer" };

  get headers(): HeadersDataTable {
    return [
      { text: "N°", value: "numero" },
      { text: "Fecha", value: "fecha" },
      { text: "Rut Prov", value: "rutProveedor" },
      { text: "Nombre Prov", value: "nombreProveedor" },
      { text: "Acción", value: "accion" },
      { text: "Ingresos", value: "ingreso" },
      { text: "Egresos", value: "egreso" },
      { text: "Documento", value: "documento" },
      { text: "Concepto", value: "concepto" },
      { text: "Comprobante", value: "tieneComprobante", sortable: true, width: "140" },
      { text: "Descripcion", value: "descripcion" },
      { text: "Acciones", value: "opciones", sortable: false, align: "end", width: "96" },
    ];
  }

  get items(): ItemsTablaCajaChicasTalca {
    return this.cajaChicasTalca.map((cajaChicaTalca) => {
      const ingreso = (parseInt(cajaChicaTalca.ingreso, 10) || 0).toCurrency({ symbol: "$" }) ?? "0";
      const egreso = (parseInt(cajaChicaTalca.egreso, 10) || 0).toCurrency({ symbol: "$" }) ?? "0";
      const archivo = cajaChicaTalca.archivo;
      const tieneComprobante = !!(archivo && typeof archivo === "object" && Object.keys(archivo).length > 0);
      return {
        numero: cajaChicaTalca.numero,
        fecha: cajaChicaTalca.fecha,
        saldoActual: cajaChicaTalca.saldoActual,
        rutProveedor: cajaChicaTalca.rutProveedor,
        nombreProveedor: cajaChicaTalca.nombreProveedor,
        accion: cajaChicaTalca.accion,
        ingreso,
        egreso,
        documento: cajaChicaTalca.documento,
        concepto: cajaChicaTalca.concepto,
        descripcion: cajaChicaTalca.descripcion,
        tieneComprobante,
        data: cajaChicaTalca,
      };
    });
  }

  getRowClass(item: { numero: number }): string {
    return `tabla-caja-gerencial__row-num-${item.numero}`;
  }

  onTableClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest("td:last-child") || target.closest("button") || target.closest(".v-menu")) return;
    const tr = target.closest("tbody tr");
    if (!tr) return;
    const match = tr.className.match(/tabla-caja-gerencial__row-num-(\d+)/);
    if (!match) return;
    const numero = parseInt(match[1], 10);
    const item = this.items.find((i) => i.numero === numero);
    if (item && item.data) this.onAbrirInfo(item.data);
  }

  @Emit("abrir-info")
  onAbrirInfo(cajaChicaTalca: CajaChicaTalca): CajaChicaTalca {
    return cajaChicaTalca;
  }

  @Emit("abrir-editar")
  onAbrirEditar(cajaChicaTalca: CajaChicaTalca): CajaChicaTalca {
    return cajaChicaTalca;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(cajaChicaTalca: CajaChicaTalca): CajaChicaTalca {
    return cajaChicaTalca;
  }
}
